/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { tableSectionStateSchema } from "./tableSectionStateSchema.ts";

export const orgUnitTableSectionsListPathOrgUnitIdSchema = z.uuid();

export const orgUnitTableSectionsListStatus200Schema = z.array(tableSectionStateSchema);

export const orgUnitTableSectionsListResponseSchema = orgUnitTableSectionsListStatus200Schema;
